export default __webpack_public_path__ + "static/media/photo_5282747746622312892_y.3affdc76.jpg";